import React, { useEffect, useState } from "react";
import "./NCXComponents.styles.css";
import { DescriptionOutlined } from "@mui/icons-material";
import { s360ConfigService } from "../../../Services/S360Config";
import FileIconPdf from "../../../../images/file-type-pdf.svg";
import apiService from "../../../Services/APIService";

function NCXFileSentMessage(props) {
  const {
    id,
    url,
    attachedSize,
    attachmentMimeType,
    attachmentTitle,
    attachmentType,
  } = props.mediaData;

  const [resolvedUrl, setResolvedUrl] = useState(false);

  const calculateFileSize = (value) => {
    value = Math.floor(parseFloat(value / 1024));
    const KB_IN_MB = 1024;
    const KB_IN_GB = 1024 * 1024;

    if (value >= KB_IN_GB) {
      return (value / KB_IN_GB).toFixed(2) + " gb";
    } else if (value >= KB_IN_MB) {
      return (value / KB_IN_MB).toFixed(2) + " mb";
    } else {
      return value + " kb";
    }
  };

  const selectFileIcon = (attachmentMimeType) => {
    switch (attachmentMimeType) {
      case "application/pdf":
        return <img src={FileIconPdf} />;
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      case "text/plain":
      default:
        return (
          <DescriptionOutlined
            fontSize="large"
            sx={{ color: "#7A7D8C" }}
            key={`${id}-filedescriptionoutlined`}
          />
        );
    }
  };

  const isValidImagePreviewUrl = (url) => {
    try {
      const parsedUrl = new URL(url);
      const pathParts = parsedUrl.pathname.split("/");
      const workItemIndex = pathParts.indexOf("workitem");

      const hasCorrectPath =
        workItemIndex > -1 &&
        pathParts[workItemIndex + 2] === "signedurl" &&
        pathParts[1] === "data" &&
        pathParts[2] === "api";

      const hasFilename = parsedUrl.searchParams.has("filename");
      const hasToken = parsedUrl.searchParams.has("token");

      return hasCorrectPath && hasFilename && hasToken;
    } catch (e) {
      return false;
    }
  };

  const extractUrlData = (url) => {
    try {
      const parsedUrl = new URL(url);
      const pathParts = parsedUrl.pathname.split("/");
      const workItemIdIndex = pathParts.indexOf("workitem") + 1;
      const workItemId = pathParts[workItemIdIndex];
      const fileName = parsedUrl.searchParams.get("filename") || "";

      return {
        workItemId,
        fileName,
      };
    } catch (error) {
      console.error("Invalid URL:", error);
      return {
        workItemId: null,
        fileName: null,
      };
    }
  };

  const fetchSignedUrl = async (url) => {
    const { workItemId, fileName } = extractUrlData(url);
    if (workItemId && fileName) {
      const data = await apiService.getMediaUrl(workItemId, fileName);
      setResolvedUrl(data?.data?.signedURL);
    }
  };

  useEffect(() => {
    if (!resolvedUrl && isValidImagePreviewUrl(url)) {
      fetchSignedUrl(url);
    }
  }, []);

  const shouldShowImage =
    attachmentType === "IMAGE" && isValidImagePreviewUrl(url);

  return (
    <div
      className={`fileSentMessageStickRight ${
        s360ConfigService?.config?.preview
          ? "fileSentMessageStickRightPreview"
          : "fileSentMessageStickRightWidget"
      }`}
      key={`${id}-fileSentMessageStickRight`}
    >
      {shouldShowImage ? (
        resolvedUrl && (
          <img
            src={resolvedUrl}
            alt={id}
            className="fileSentMessageImg"
            loading="lazy"
            key={`${id}-fileSentMessageImg`}
            onClick={() => window.open(url, '_blank')}
          />
        )
      ) : (
        <div
          className="fileSentMessageTextContainer"
          key={`${id}-fileSentMessageTextContainer`}
        >
          {selectFileIcon(attachmentMimeType)}
          <div
            className="fileSentMessageTextVertical"
            key={`${id}-fileSentMessageTextVertical`}
          >
            <span
              className="fileSentMessageText"
              key={`${id}-fileSentMessageText`}
            >
              {attachmentTitle}
            </span>
            <span
              className="fileSentMessageTextSize"
              key={`${id}-fileSentMessageTextSize`}
            >
              {calculateFileSize(attachedSize)}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default NCXFileSentMessage;
